import { render, staticRenderFns } from "./BoningView.vue?vue&type=template&id=2338723c&scoped=true"
import script from "./BoningView.vue?vue&type=script&setup=true&lang=js"
export * from "./BoningView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BoningView.vue?vue&type=style&index=0&id=2338723c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2338723c",
  null
  
)

export default component.exports